import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Spinner, Button } from "react-bootstrap";
import { CSVLink } from "react-csv";
import Pagination from "../Pagination/Pagination";
import Nafuda from "./Nafuda";

//import { jsPDF } from "jspdf";
//import ReactDOMServer from "react-dom/server";

export default function ListNafudaKake(props) {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");
  const [isLoading, setLoading] = useState(false);
  const [isPrint, setPrint] = useState(false);
  const [users, setUsers] = useState([]);
  const token = JSON.parse(ls.get("jwt"));
  const usuario = JSON.parse(ls.get("userData"));
  var moment = require("moment");

  const isAdmin = usuario.level == 3 ? true : false;

  const PAGE_SIZE = 100;
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({});
  const [pageUsers, setPageUsers] = useState([]);

  useEffect(() => {
    users.length === 0 ? GetUsers() : FilterUsers(users, currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const FilterUsers = (users, page) => {
    setPageUsers(
      users.filter(
        (u, idx) => idx >= (page - 1) * PAGE_SIZE && idx < page * PAGE_SIZE
      )
    );
  };

  // const PrintKake = () => {
  //   const doc = new jsPDF("p", "pt", [793, 1122]);
  //   let htmlString = ReactDOMServer.renderToString(renderPrint);
  //   htmlString = `<div style="vertical-align: top; margin-top: 20px">${htmlString}</div>`;
  //   console.log({ htmlString });
  //   doc.html(htmlString, {
  //     callback: () => {
  //       doc.save(`FAA_Nafudakake.pdf`);
  //     },
  //   });
  // };

  const GetUsers = () => {
    setLoading(true);
    axios
      .get(
        `${API_URL}/users?populate=exams.grade&pagination[pageSize]=2000`,
        headerRequest
      )
      .then((users) => {
        let userGrades = [];
        for (let i = 0; i < users.data.length; i++) {
          let u = users.data[i];
          if (u.active == false) continue;
          if (u.exams?.length > 0) {
            // obtener graduacion actual del alumno
            const filteredExams = u.exams.filter(
              (x) =>
                x.grade.rank != "DAN" ||
                (x.grade.rank == "DAN" &&
                  x.dateAikikai &&
                  x.dateAikikai != null &&
                  x.dateAikikai != "")
            );
            filteredExams.sort(function (a, b) {
              return b.grade.id - a.grade.id;
            });

            const e = filteredExams[0];
            if (e) {
              let x = {
                id: u.id,
                docNumber: u.docNumber,
                lastname: u.lastname,
                name: u.name,
                fullname: u.lastname + ", " + u.name,
                date:
                  e.dateAikikai && e.dateAikikai != null && e.dateAikikai != ""
                    ? e.dateAikikai
                    : e.date,
                gradeId: e.grade?.id,
                grade: e.grade?.name,
              };
              userGrades.push(x);
            }
          }
        }

        const sortedUserGrades = userGrades.sort(function (a, b) {
          return (
            b.gradeId - a.gradeId ||
            moment(a.date).toDate() - moment(b.date).toDate()
          );
        });

        setUsers(sortedUserGrades);
        setPagination({ total: sortedUserGrades.length });
        FilterUsers(sortedUserGrades, 1);
        setLoading(false);
      });
  };

  const renderPrint = (
    <>
      <div
        style={{
          verticalAlign: "top",
          marginTop: "20px",
        }}
      >
        {pageUsers.map((data, index, array) => (
          <Nafuda
            exam={data}
            key={data.id}
            prev={index === 0 ? null : array[index - 1]}
          />
        ))}
      </div>
      <Pagination
        className="pagination-bar"
        currentPage={currentPage}
        totalCount={pagination.total}
        pageSize={PAGE_SIZE}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </>
  );

  const renderData = (
    <>
      <Table striped hover size="sm" responsive="sm">
        <thead>
          <tr>
            <th>Grado</th>
            {isAdmin ? <th>DNI</th> : null}
            <th>Nombre</th>
            <th>Fecha</th>
          </tr>
        </thead>
        <tbody>
          {!users || users.length < 1 ? (
            <tr>
              <td colSpan="4" align="center">
                No hay datos.
              </td>
            </tr>
          ) : (
            pageUsers.map((u, index) => (
              <tr key={index}>
                <td align="center">{u.grade}</td>
                {isAdmin ? <td align="center">{u.docNumber}</td> : null}
                <td align="left">{u.fullname}</td>
                <td align="center">{u.date}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      <Pagination
        className="pagination-bar"
        currentPage={currentPage}
        totalCount={pagination.total}
        pageSize={PAGE_SIZE}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </>
  );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3">
      <h4>NAFUDA KAKE (名札掛け)</h4>
      {!isLoading && users && users.length > 1 ? (
        <>
          {isAdmin ? (
            <CSVLink
              data={users}
              filename={"faa-nafudakake.csv"}
              className="btn btn-success btn-sm"
            >
              DESCARGAR
            </CSVLink>
          ) : null}{" "}
          <Button
            size="sm mr-1"
            variant="secondary"
            disabled={isLoading && !users && users.length < 1}
            onClick={(e) => {
              setPrint(!isPrint);
            }}
          >
            KAKE
          </Button>
        </>
      ) : null}
      {isLoading ? (
        <Spinner animation="border" />
      ) : isPrint ? (
        renderPrint
      ) : (
        renderData
      )}
    </Container>
  );
}
